<dcr-score
  [value]="hasScore ? result.score : undefined"
  [isPending]="hasScore && anyIncomplete"
  [attempts]="attemptedClasses"
  [type]="type"
  [manualGrading]="!!manualGrading"
></dcr-score>
